import React from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from "recharts";

const data = [
  { name: "COGS", value: 0.26 },
  { name: "GROSS PROFIT", value: 0.74 },
];

const COLORS = ["#DC2023", "#D3D3D3"];

const renderCustomLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  payload,
  index,
}) => {
  const { name, value } = payload;
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <g>
      <text
        x={cx + (radius + 200) * Math.cos(-midAngle * RADIAN)}
        y={cy + (radius + 120) * Math.sin(-midAngle * RADIAN)}
        fill="#3E3E3E"
        textAnchor="middle"
        fontWeight={700}
        dominantBaseline="central"
      >
        {name}
      </text>
      <text
        x={cx + (radius + 200) * Math.cos(-midAngle * RADIAN)}
        y={cy + (radius + 80) * Math.sin(-midAngle * RADIAN)}
        fill="#3E3E3E"
        textAnchor="middle"
        fontWeight={700}
        dominantBaseline="central"
      >
        {`${(value * 100).toFixed(0)}%`}
      </text>
      <polyline
        points={[
          [
            cx + (radius + 30) * Math.cos(-midAngle * RADIAN),
            cy + (radius + 30) * Math.sin(-midAngle * RADIAN),
          ],
          [
            cx + (radius + 100) * Math.cos(-midAngle * RADIAN),
            cy + (radius + 100) * Math.sin(-midAngle * RADIAN),
          ],

          [
            cx + (radius + 300) * Math.cos(-midAngle * RADIAN),
            cy + (radius + 100) * Math.sin(-midAngle * RADIAN),
          ],
        ]}
        stroke={COLORS[index % COLORS.length]}
        strokeWidth={2}
        fill="none"
      />
      <circle
        cx={cx + (radius + 30) * Math.cos(-midAngle * RADIAN)}
        cy={cy + (radius + 30) * Math.sin(-midAngle * RADIAN)}
        r={8}
        fill="#DC2023"
        stroke="#F2F2F2"
        strokeWidth={4}
      />
    </g>
  );
};

const RevenuesChart = () => {
  return (
    <>
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data}
            innerRadius="50%"
            dataKey="value"
            stroke="none"
            label={renderCustomLabel}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </>
  );
};

export default RevenuesChart;
